import {ApiModel} from './api-model';
import { Language } from './language';

export class ExistingRule extends ApiModel {
  ruleId: number;
  language: Language;
  destination: string;
  selected: boolean;

  constructor(data: any) {
    super(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/existing-rule.ts